import React from 'react';
import { Alert, Button } from 'reactstrap';
import { fleetPanelData } from './fleetPanelData';

/**
 * "Your fleet has moved on from what this project reviews."
 *
 * Kept separate from the stat tiles because it is a call to action, not a
 * statistic, and separate from the components card because it is about the
 * version rather than the modules. It appears only when the fleet's majority
 * has actually diverged from the baseline, which for most projects is never.
 *
 * The project itself is never repointed — a review in progress must not shift
 * under the reviewer — so the only offer is a new project for the new version.
 */
const InventoryDriftAlert = ({ project, onCreateForVersion }) => {
  const data = fleetPanelData(project);
  if (!data || !data.hasDrift) return null;

  return (
    <Alert color="warning" className="mb-3" fade={false}>
      This project reviews <strong>{data.baseline}</strong>. Your inventory&apos;s majority is now{' '}
      <strong>{data.majorityVersion}</strong>.{' '}
      <Button
        color="link"
        size="sm"
        className="p-0 align-baseline"
        onClick={() => onCreateForVersion(data.majorityVersion)}
      >
        Create a project for {data.majorityVersion}
      </Button>
    </Alert>
  );
};

export default InventoryDriftAlert;
